<template>
  <div class="container bg-hui">
    <div class="content-box p48 predict">
      <div class="number"><b>{{data.totalRealFee | calcPriceFun}}</b>元</div>
      <ul class="priceList" v-if="data.chargeType != 4">
        <li v-if="data.startPrice"><span>{{data.startPrice | calcPriceFun}}元</span>起步价<i>({{data.startkilometers
          |
          meters}}公里)</i>
        </li>
        <li v-if="data.orderMileageFee">
          <span>{{data.orderMileageFee | calcPriceFun}}元</span>里程费<i>({{data.orderMileages |
          meters}}公里)</i>
        </li>
        <li v-if="data.longTimeFee"><span>{{data.longTimeFee | calcPriceFun}}元</span>时长费<i>({{data.longTimes
          |
          formatDuringFun}})</i></li>
        <li v-if="data.longDistanceFee">
          <span>{{data.longDistanceFee | calcPriceFun}}元</span>远途费<i>({{data.longDistances |
          meters}}公里)</i>
        </li>
        <li v-if="data.waitTimeFee"><span>{{data.waitTimeFee | calcPriceFun}}元</span>等候费<i>({{data.waitTimes
          |
          formatDuringFun}})</i></li>
        <li v-if="data.dynamicPrice"><span>{{data.dynamicPrice | calcPriceFun}}元</span>动态加价</li>
        <li v-if="data.insuranceFee"><span>{{data.insuranceFee | calcPriceFun}}元</span>基础信息服务费</li>
        <li v-if="data.reductionFee"><span>-{{data.reductionFee | calcPriceFun}}元</span>司机减免</li>
        <li v-if="data.coupon"><span>-{{data.coupon | calcPriceFun}}元</span>优惠券</li>
        <li v-if="data.parkWaitFee"><span>{{ data.parkWaitFee | calcPriceFun }}元</span>停车等候费</li>
        <li v-if="data.otherFee"><span>{{ data.otherFee | calcPriceFun }}元</span>附加费</li>
        <li v-if="data.otherFee" class="fontSize"><span>{{ data.roadFee | calcPriceFun }}元</span>路桥费
        </li>
        <li v-if="data.otherFee" class="fontSize"><span>{{ data.parkFee | calcPriceFun }}元</span>停车费
        </li>
        <li v-if="data.otherFee" class="fontSize"><span>{{ data.elseFee | calcPriceFun }}元</span>其他费用
        </li>
      </ul>
      <ul class="priceList" v-else>
        <li v-if="data.fixedFee"><span>{{data.fixedFee | calcPriceFun}}元</span>一口价<template v-if="data.fixedOverMileage">(含超出{{ data.fixedOverMileage | meters }}公里{{ data.fixedOverMileageFee | calcPriceFun }}元)</template></li>
        <li v-if="data.insuranceFee"><span>{{data.insuranceFee | calcPriceFun}}元</span>基础信息服务费</li>
		<li v-if="data.reductionFee"><span>-{{data.reductionFee | calcPriceFun}}元</span>司机减免</li>
        <li v-if="data.otherFee"><span>{{data.otherFee | calcPriceFun}}元</span>其他费用</li>
        <li v-if="data.coupon"><span>-{{data.coupon | calcPriceFun}}元</span>优惠券</li>
      </ul>
      <hr>
      <div class="font-gray">若您对车费有疑问，可以点击下方按钮联系客服，我们会在24小时内与您联系！</div>
    </div>
    <div style="padding-top: .25rem;">
      <van-row type="flex" justify="space-around">
        <van-col span="24">
          <div class="text-center font-hui">
            <a @click="clickJF()">计费规则<span class="iconfont icon-youjiantou"></span>
            </a>
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="contact-font" @click="callTel2"><img src="../../assets/img/icon-tel.png"/> 联系客服
    </div>
  </div>
</template>

<script>
  import mobileType from '@/utils/mobileType';
  import util from '../../utils/util';
  import {
    changeInitiatePayment,
  } from '@/apis/order/order';

  export default {
    data() {
      return {
        data: {
          orderId: null,
          couponId: null,
        },
        datas: {},
      };
    },
    created() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      let data = decodeURIComponent(this.$route.query.data);
      this.datas = JSON.parse(data);
    //   this.getInfo();
      if (this.datas.platform == 3) {
        this.getInfo();
      } else {
        this.getUserInfoFromApp();
      }
    },
    filters: {
      calcPriceFun(val) {
        return util.calcPrice(val);
      },
      meters(val) {
        if (val) {
          const int = val / 1000;
          return util.getFloat(int, 1);
        } else {
          return 0.0;
        }
      },
      formatDuringFun(val) {
        return util.formatDuring(val);
      },
    },
    methods: {
      getUserInfoFromApp() {
        let params = {
          methodName: 'getDataFromNative',//定义与原生的方法名(固定)
          type: 1,//业务类型(固定)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        } else {
        }
      },
      getDataFromNative(params) {
        if (mobileType.isIOS()) {
          this.params = params;
        } else if (mobileType.isAndroid()) {
          this.params = JSON.parse(params);
        }
        this.getInfo();
      },
      // 跳转计费规则
      clickJF() {
        let path = '/home/accountingRules';
        if(this.data.chargeType && this.data.chargeType == 4){
            path = '/home/accountingRulesFixed';
        }
        if (this.datas.platform == 3) {
          this.$router.push({
            path: path,
            query: {
              areaCode: this.datas.areaCode,
              channel: this.datas.channel,
              deviceId: this.datas.deviceId,
              display: this.datas.display,
              imei: this.datas.imei,
              imsi: this.datas.imsi,
              platform: this.datas.platform,
              softVersion: this.datas.softVersion,
              sysVersion: this.datas.sysVersion,
              token: this.datas.token,
              cityCode: this.datas.cityCode,
              orderType: this.datas.orderType,
              lat: this.datas.lat,
              lon: this.datas.lon,
              orderId: this.datas.orderId || '',
              chargeType: this.data.chargeType
            }
          });
        } else {
          this.$router.push({
            path: path,
            query: {
              cityCode: this.datas.cityCode,
              orderType: this.datas.orderType,
              lat: this.datas.lat,
              lon: this.datas.lon,
              orderId: this.datas.orderId || '',
              chargeType: this.data.chargeType
            }
          });
        }
      },
      callTel2() {
        window.location.href = 'tel://4006-424-887';
      },
      // 获取数据
      async getInfo() {
        // let params = {
        //   areaCode: '110105',
        //   channel: '1020000000',
        //   data: {
        //     orderId: '10107007111010010152',
        //   },
        //   deviceId: '076cf0ae-9f57-44d4-b59a-9590dedbf65b',
        //   display: '1440*2392',
        //   imei: '10086e48-d6bf-4dce-a496-e5116438130b',
        //   imsi: '未授权电话权限',
        //   lat: 39.898051,
        //   lon: 116.491295,
        //   platform: '3',
        //   softVersion: '4.8.0',
        //   sysVersion: 'TNY-AL00,10',
        //   token: 'MTAxMTAwMDcxMzE6MTAwOjIwMjAwNTIwMTUyNjA0OTIx'
        // };
        let params;
        if (this.datas.platform == 3) {
          params = {
            areaCode: this.datas.areaCode,
            channel: this.datas.channel,
            data: {
              orderId: this.datas.orderId,
              couponId: this.datas.couponId
            },
            deviceId: this.datas.deviceId,
            display: this.datas.display,
            imei: this.datas.imei,
            imsi: this.datas.imsi,
            lat: this.datas.lat,
            lon: this.datas.lon,
            platform: this.datas.platform,
            softVersion: this.datas.softVersion,
            sysVersion: this.datas.sysVersion,
            token: this.datas.token,
            chargeType: this.datas.chargeType
          };
        } else {
          params = {
            areaCode: this.params.areaCode,
            channel: this.params.channel,
            data: {
              orderId: this.datas.orderId,
              couponId: this.datas.couponId
            },
            deviceId: this.params.deviceId,
            display: this.params.display,
            imei: this.params.imei,
            imsi: this.params.imsi,
            lat: this.params.lat,
            lon: this.params.lon,
            platform: this.params.platform,
            softVersion: this.params.softVersion,
            sysVersion: this.params.sysVersion,
            token: this.params.token,
            chargeType: this.params.chargeType
          };
        }
        params.data = JSON.stringify(params.data);
        try {
          const data = await changeInitiatePayment(params);
          console.log(data);
          if (data.code == 1 && data.data) {
            this.$toast.clear();
            this.data = JSON.parse(data.data);
          }
        } catch (error) {
        }
      },
    },
  };
</script>
<style scoped lang="less">
  .p48 {
    padding: 1rem 3rem 1.25rem 3rem;
  }

  .number {
    text-align: center;
    font-size: 0.9375rem;
    color: #333333;
    line-height: 1.3125rem;
    padding-bottom: 1rem;

    b {
      font-size: 1.5rem;
      font-weight: 400;
    }
  }


  hr {
    margin: 1rem 0;
    border-bottom: none;
    border-left: none;
    border-right: none;
    border-top: solid 0.0625rem #ECECEC;
  }

  .font-gray {
    font-size: 0.75rem;
    color: #999999;
    line-height: 1.0625rem;
  }

  .font-hui {
    font-size: 0.75rem;
    color: #666666;
    line-height: 1.0625rem;
  }

  .icon-youjiantou:before {
    position: relative;
    top: 0.125rem;
    background: #F4F5F6;
  }

  .contact-font {
    font-size: 0.875rem;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 1.25rem;
    text-align: center;
    /*padding-top: 10.6875rem;*/
    position: fixed;
    width: 100%;
    bottom: 1.875rem;

    img {
      width: 0.875rem;
      height: auto;
      margin-top: 2.5px;
      vertical-align: top;
      /*margin-right: 0.25rem;*/
    }
  }
  .predict .priceList li.fontSize {
    font-size: 13px;
    color: #666;
    padding: 0;
  }
</style>

